import "./ResponsiveTable.css";
import "./ResponsiveTableLayout.css";
import "./ResizableTable.css";

import {
  Table,
  OverlayTrigger,
  Tooltip,
  Form,
  Row,
  Col,
  Container,
  Image,
  Button,
  Card
} from "react-bootstrap";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { BsPlusLg } from "react-icons/bs";
import Sort from "./Sort";
import Pagination from "./Pagination";
import Filter from "./Filter";
import GlobalSearch from "./GlobalSearch";
import ExcelDownload from "./ExcelDownload";
import constants from "../../helpers/constants";
import xFilter from "../../assets/icons/x-close.svg";
import { searchAll } from "./common-filter";
import { resizableColumn } from "./ResizableTable";
import { AuthContext } from "../../contexts/AuthContext";
import dotIcon from "../../assets/icons/ThreeDotIcon.svg";
import noData from "../../assets/images/NoData.svg";
import filter from "../../assets/icons/FilterGreyIcon.svg";
import filterOn from "../../assets/icons/FilterActiveGrey.svg";
import { toLower } from "lodash";
import { Switch } from "@mui/material";
import FilterColumn from "./FilterColumn";
import { formatDate } from "../../helpers/date-formatter";
import refreshIcon from "../../assets/icons/Refresh.svg";

export default function ResponsiveTable(props) {

  console.log("props.headersprops.headers:: ", props.selectedData)

  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchList, setSearchList] = useState({});
  const [showDownButn, setShowDownButn] = useState(true);
  const [writeAccess, setWriteAccess] = useState(false);
  const [sortList, setSortList] = useState({});
  const [gridHeader, setGridHeader] = useState(props.headers);
  const [selectedData, setSelectedData] = useState(
    props.selectedData ? props.selectedData : []
  );
  const [activeColumn, setActiveColumn] = useState(0);
  const [inactiveColumn, setInactiveColumn] = useState(0);
  const [selectAll, setSelectAll] = useState(false);
  const paginationView = props.paginationView;
  const tableApproverView = props.tableApproverView;
  const [showMore, setShowMore] = useState({});
  const [statusColumn, setStatusColumn] = useState("EnquiryStatus" || "Status");
  const [selectedRow, setSelectedRow] = useState(props.selectedRow);
  const [pageSize, setPageSize] = useState(() => {
    return Number(sessionStorage.getItem(`pageSize_${props.sessionName}`)) || 10;
  });
  const [showFilters, setShowFilters] = useState(false);

  const toggleFilters = () => {
    setShowFilters(!showFilters);
  };
  const context = useContext(AuthContext);

  useEffect(() => {
    sessionStorage.setItem(`pageSize_${props.sessionName}`, pageSize);
  }, [pageSize, props.sessionName]);

  useEffect(() => {
    let propsTemp = { setData: setData, data: props.data, header: gridHeader };
    console.log("data :::::: ", propsTemp);
    searchAll(propsTemp, searchList);
    setSortList({});
    setSelectAll(false);
    setCurrentPage(1);
  }, [props.data]);

  useEffect(() => {
    setSearchList({});
  }, [props.dataType]);

  useEffect(() => {
    if (!props.noHeader && sessionStorage.getItem(`grid_${props.dataType}`)) {
      const columnGridVar = JSON.parse(sessionStorage.getItem(`grid_${props.dataType}`));
      console.log("print 1: columnGridVar", columnGridVar);
      console.log("print1: ", props.headers);
      setGridHeader(columnGridVar);
      //sessionStorage.setItem(`grid_${props.sessionName}`, JSON.stringify(props.headers));
    }

    if (props.noHeader) {
      setGridHeader(props.headers);
    }
    //setGridHeader(props.headers);
    let statusCol = "";
    for (let header of props.headers) {
      if (header.status || header.displayName === "Status" || header.displayName === "EnquiryStatus") {
        statusCol = header.columnName;
        setStatusColumn(statusCol);
      }
    }

    if (statusCol) {
      const active = props.data ? props?.data?.filter((row) => row.enable === "Active").length : 0;
      const inactive = props.data ? props?.data?.filter(
        (row) => row.enable === "Inactive"
      ).length : 0;
      setActiveColumn(active);
      setInactiveColumn(inactive);
    }
  }, [props.headers, props.data]);

  useEffect(() => {
    resizableColumn(props.dataType + "_table");
  }, [gridHeader]);

  useEffect(() => {
    setSelectedData(props.selectedData ? props.selectedData : []);
  }, [props.selectedData]);

  useEffect(() => {
    if (props.setSelectedData) {
      props.setSelectedData(selectedData);
    }
  }, [selectedData]);

  useEffect(() => {
    let tmpMenu = {};

    let AuthorizedSessionstmp = context.authorizedSessions;
    if (AuthorizedSessionstmp && AuthorizedSessionstmp != "") {
      // AuthorizedSessionstmp = JSON.parse(AuthorizedSessionstmp);
      AuthorizedSessionstmp?.forEach((obj) => {
        const key = Object.keys(obj)[0];
        tmpMenu[key] = obj[key];
      });
      console.log(" tmpMenu ", tmpMenu);
      let AuthorizedSessions = tmpMenu;

      // for (let parentMenu in AuthorizedSessions) {
      //   if (AuthorizedSessions[parentMenu]) {
      //     for (let menu of AuthorizedSessions[parentMenu]) {
      //       if (menu.submenu == props.sessionName && menu.Write) {
      //         setWriteAccess(true);
      //         break;
      //       }
      //     }
      //   }
      // }
    }

    console.log(" setWriteAccess ", writeAccess);
  }, [props.sessionName]);

  // const [filteredResult, setFilteredResult] = useState(() => {
  const filteredResult = useMemo(() => {
    setShowMore({});
    let firstPageIndex = 0;
    if (currentPage > 1) {
      console.log("currenPage", currentPage);
      firstPageIndex = (currentPage - 1) * pageSize;
    }
    if (firstPageIndex >= data?.length) {
      firstPageIndex = 0;
      const totalPageCount = Math.ceil(data?.length / pageSize);
      if (totalPageCount > 0) {
        setCurrentPage(totalPageCount);
      } else {
        setCurrentPage(1);
      }
    }

    let lastPageIndex = parseInt(firstPageIndex) + parseInt(pageSize);

    return data && data.length ? data.slice(firstPageIndex, lastPageIndex) : [];
  }, [currentPage, data, pageSize]);



  // const [filteredData, setFilteredData] = useState(data)
  // console.log("ffffffffffffffffffff", data, filteredResult, filteredData )
  // useEffect(() => {
  //   setFilteredData(filteredResult);
  // }, [filteredResult]);

  const handleChangeCheckbox = (e, item) => {
    let tempSelectedData = [];
    Object.assign(tempSelectedData, selectedData);
    if (e.target.checked) {
      tempSelectedData.push(item);
    } else {
      const index = tempSelectedData.findIndex((element) => element === item);
      if (index !== -1) {
        tempSelectedData.splice(index, 1);
      }
    }
    setSelectedData(tempSelectedData);
    if (props.setSelectedData) {
      props.setSelectedData(tempSelectedData);
    }

    if (tempSelectedData.length == data.length) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }
  };

  const handleSelectAll = (e) => {
    let tempdata = [];
    if (e.target.checked) {
      for (let item of data) {
        if (
          props.checkBoxValidation == undefined ||
          props.checkBoxValidation(item)
        ) {
          tempdata.push(item);
        }
      }
      for (let item of selectedData) {
        if (
          props.checkBoxValidation == undefined ||
          props.checkBoxValidation(item)
        ) {
          const index = tempdata.findIndex((element) => element === item);
          if (index === -1) {
            tempdata.push(item);
          }
        }
      }
    }
    setSelectedData(tempdata);
    if (props.setSelectedData) {
      props.setSelectedData(tempdata);
    }
    setSelectAll(e.target.checked);
  };

  const toggleIcons = (itemIndex) => {
    setSelectedRow(itemIndex === selectedRow ? null : itemIndex);
    props.setShowEditIcon(true);
  };

  const handleShowMore = (index) => {
    if (showMore[index]) {
      setShowMore((prev) => ({ ...prev, [index]: false }));
    }
    else {
      setShowMore((prev) => ({ ...prev, [index]: true }));
    }
  }

  return (
    <Container bsPrefix="custom-grid" className={`${props.data?.length <= 0 ? "no-grid-data" : ""}`} style={props.noHeader ? { marginTop: 0 } : {}}>
      <Row bsPrefix="grid">
        {!props.noHeader && <Row className="contain-header">
          {!props.noHeader && <Col>
            <div className="session-name">{props.sessionName}</div>
          </Col>}
          <Col
            md={props.searchmd}
            sm={12}
            xs={12}
            className="search-container"
          >
            <div className="global-search-container">
              {!(selectedData.length > 0 && props.DisplayExcelDownload) && (
                <>
                  {!props.noSearch && <GlobalSearch
                    className="table-border global-search-col "
                    setData={setData}
                    headers={gridHeader}
                    data={props.data}
                    setShowDownButn={setShowDownButn}
                    showDownButn={showDownButn}
                    isSearchOpen={props.isSearchOpen}
                    searchList={searchList}
                    dataType={props.dataType}
                    sessionName={props.sessionName}
                  ></GlobalSearch>}

                  {props.sessionName !== "Discount Sanction" && props.sessionName !== "Pre-Order Timeline" && props.sessionName !== "Order Booking" && (
                    <Button
                      bsPrefix="btn-primary add-btn"
                      onClick={props.handleAdd}
                    >
                      <BsPlusLg size={24} className="btn-clr p-2 ms-2" />
                      <span className="btn-text">Add {props.sessionName}</span>
                    </Button>
                  )}

                  {/* <OverlayTrigger
                    placement="bottom"
                    overlay={<Tooltip className="custom-tooltip">Refresh</Tooltip>}
                  >
                    <img
                      src={refreshIcon}
                      alt="arrow"
                      Tooltip="Refresh"
                      className="refresh-icon"
                      onClick={props.loadform}
                    />
                  </OverlayTrigger> */}



                </>
              )}
              {selectedData.length > 0 && props.DisplayExcelDownload && (
                <ExcelDownload
                  downloadData={true}
                  fileName={props.dataType}
                  className="download-btn-col"
                  headers={props.headers}
                  data={selectedData}
                />
              )}
            </div>
          </Col>
        </Row>}

        <Row className="filter-table-head">
          <Col className="filter-selected-col gap-2">
            {searchList &&
              Object.keys(searchList).map((key, index) => {
                let filterValueSelected =
                  searchList[key][0] && searchList[key][0] != ""
                    ? searchList[key].displayName + ": " + searchList[key][0]
                    : "";
                filterValueSelected =
                  searchList[key][1] &&
                    searchList[key][1] != "" &&
                    searchList[key].condition != ""
                    ? filterValueSelected +
                    " " +
                    searchList[key].condition +
                    " " +
                    searchList[key][1]
                    : filterValueSelected;
                if (searchList[key].filterType == "Range") {
                  filterValueSelected =
                    searchList[key][1] && searchList[key][1] != ""
                      ? filterValueSelected + " To " + searchList[key][1]
                      : filterValueSelected;
                }
                if (
                  searchList[key].filterType == "Blank" ||
                  searchList[key].filterType == "Not Blank"
                ) {
                  filterValueSelected =
                    searchList[key].displayName +
                    ":" +
                    searchList[key].filterType;
                }
                if (key == "GlobalSearch") {
                  filterValueSelected = "";
                }
                return (
                  <React.Fragment key={filterValueSelected}>
                    {filterValueSelected && (
                      <div className="filter-selected">
                        <span className="filter-selected-label">
                          {filterValueSelected}
                        </span>
                        <Image
                          className="filter-selected-cross"
                          src={xFilter}
                          onClick={() => {
                            searchList[key][0] = "";
                            searchList[key][1] = "";
                            searchList[key].filterType = "";
                            let propsTemp = {
                              setData: setData,
                              data: props.data,
                              header: gridHeader,
                            };
                            searchAll(propsTemp, searchList);
                          }}
                        ></Image>
                      </div>
                    )}
                  </React.Fragment>
                );
              })}
          </Col>

          {Object.keys(searchList).some((key) => {
            return (
              (searchList[key][0] && searchList[key][0] !== "") ||
              (searchList[key][1] && searchList[key][1] !== "") ||
              (searchList[key].filterType && searchList[key].filterType !== "")
            );
          }) && (
              <Button className="clear-all-filters"
                bsPrefix="reset-btn"
                onClick={() => {
                  Object.keys(searchList).forEach((key) => {
                    searchList[key][0] = "";
                    searchList[key][1] = "";
                    searchList[key].filterType = "";
                  });
                  let propsTemp = {
                    setData: setData,
                    data: props.data,
                    header: gridHeader,
                  };
                  searchAll(propsTemp, searchList);
                }}
              >Clear All</Button>
            )}
        </Row>

        <Container bsPrefix="custom-grid-table" style={props.noScroll ? { maxHeight: "none", overflow: "visible" } : {}}>
          {filteredResult?.length < 1 && !props.noEmptyState ? (
            <div className="no-data-container">
              <Image src={noData} alt="No data" />
              <p>No data found</p>
            </div>
          ) : (
            <Table className="responsiveTable" id={props.dataType + "_table"}>
              <thead>
                <tr className="table-border">
                  <th className="fixed space-fixed first-col-table"></th>
                  {props.DisplayExcelDownload &&
                    paginationView !== "false" &&
                    !props.noCheckbox && (
                      <th
                        className="fixed second-col-table"
                      >
                        <Form.Check
                          className="table-checkbox"
                          name="select"
                          onChange={handleSelectAll}
                          checked={selectAll}
                        ></Form.Check>
                      </th>
                    )}

                  {gridHeader.map((header, index) =>
                  // for hide show column
                  {
                    return (
                      header.displayIndication && (
                        <th
                          key={props.dataType + "_table" + index}
                          className={`${header.fixed ? "fixed" : ""}`}
                          style={{
                            width: header.width + "px",
                            right: header.right,
                          }}
                        >
                          <div className="table-th">
                            {header.displayName}

                            <Sort
                              data={data}
                              setData={setData}
                              sortList={sortList}
                              setSortList={setSortList}
                              field={header.columnName}
                            ></Sort>
                            <Filter
                              index={index}
                              data={props.data}
                              columnName={header.columnName}
                              displayName={header.displayName}
                              setData={setData}
                              searchList={searchList}
                              dataType={header.dataType}
                              header={gridHeader}
                            />
                          </div>
                        </th>
                      )
                    );
                  }
                  )}


                  {props.icons && (
                    <th
                      className="fixed icon"
                      style={{
                        right: 0,
                        // width: props.noHeader ? "auto" : (props?.icons?.length * 30 + 50 + "px"),
                        float: props.noHeader ? "none" : "right",
                        backgroundColor: "#f8f8f6",
                        zIndex: 2,
                        borderRight: props.noHeader ? "none" : undefined,
                      }}
                    >
                      <div className={props.noHeader ? "table-th" : "action-column"} style={props.noHeader ? { justifyContent: "flex-end", paddingRight: "20px" } : {}}>Action</div>
                      {!props.noHeader && props?.icons?.map((icon, index) => (
                        <div key={index}>&nbsp;</div>
                      ))}
                    </th>
                  )}
                </tr>
              </thead>

              <tbody>
                {filteredResult.map((item, itemIndex) => (
                  <tr className="table-border" key={itemIndex}>

                    <td className="fixed first-col-table" ></td>

                    {props.DisplayExcelDownload &&
                      paginationView !== "false" &&
                      !props.noCheckbox && (
                        <td
                          className="fixed second-col-table"
                        >
                          {(props.checkBoxValidation == undefined ||
                            props.checkBoxValidation(item)) && (
                              <Form.Check
                                name="select"
                                checked={
                                  selectedData.length > 0
                                    ? selectedData.filter((e) => e === item)
                                      .length <= 0
                                      ? false
                                      : true
                                    : false
                                }
                                className="table-checkbox"
                                onChange={(e) => {
                                  handleChangeCheckbox(e, item);
                                }}
                              ></Form.Check>
                            )}
                        </td>
                      )}

                    {gridHeader.map((header, index) =>
                    // for hide show column
                    {
                      // let formattedValue = header.formatter
                      //   ? header.formatter(
                      //     item[header.columnName],
                      //     header,
                      //     item
                      //   )
                      //   : item[header.columnName];

                      let formattedValue = (header.formatter || header.dataType === 'date') ? formatDate(item[header.columnName]) : item[header.columnName];

                      let displayValue = header.cssFormatter
                        ? header.cssFormatter(formattedValue, header, item, itemIndex)
                        : formattedValue;

                      return (
                        header.displayIndication && (
                          <td
                            key={itemIndex + " " + index}
                            className={`${header.fixed ? "fixed" : ""}`}
                            onClick={() =>
                              paginationView == "false" && tableApproverView
                            }
                          >
                            <div className={`responsive-td ${displayValue}`}>
                              {header.switch && <>{displayValue} </>}

                              {!header.switch && (
                                <div className="tooltip-table">
                                  <OverlayTrigger
                                    placement="bottom"
                                    overlay={
                                      <Tooltip className="custom-tooltip">
                                        {formattedValue}
                                      </Tooltip>
                                    }
                                  >
                                    <div className="table-display-value">
                                      {displayValue}
                                    </div>
                                  </OverlayTrigger>
                                </div>
                              )}
                            </div>
                          </td>
                        )
                      );
                    }
                    )}

                    {props.icons && (
                      props.noHeader ? (
                        <td
                          className="fixed"
                          style={{
                            right: 0,
                            textAlign: "right",
                            paddingRight: "20px",
                            verticalAlign: "middle",
                            borderRight: "none",
                          }}
                        >
                          {props.icons?.map((icon, index) => (
                            <span key={index} onClick={() => icon.click(item)} style={{ cursor: "pointer", marginLeft: "12px", display: "inline-block" }}>
                              <Image width={"28px"} height={"28px"} src={icon.src} />
                            </span>
                          ))}
                        </td>
                      ) : (
                        <td
                          className="fixed icon"
                          style={{
                            right: 0,
                            // width: props?.icons?.length * 30 + 50 + "px",
                            alignItems: "center",
                          }}
                        >
                          {props.icons?.map((icon, index) => (
                            <div key={index} onClick={() => icon.click(item)} className="three-dot-icon">
                              <Image
                                width={"17px"}
                                className="table-icon icon-hover"
                                src={icon.src}
                              />
                            </div>
                          ))}
                        </td>
                      )
                    )}
                  </tr>
                ))}

                {filteredResult.length < 1 && !props.noEmptyState && (
                  <tr>
                    <td
                      colSpan={
                        activeColumn +
                        1 +
                        (props.icons ? 1 : 0) +
                        (props.noCheckbox ? 0 : 1)
                      }
                    >
                      <div className="responsive-td">
                        <Image src={noData} />
                        No data found
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}
        </Container>

        <div className="responsive-div">

          <div className="filter-column-out">
            <Button className="filtered-column" onClick={toggleFilters}>
              {showFilters ? <img src={filterOn} alt="Filter On" /> : <img src={filter} alt="Filter" />}
            </Button>
            {showFilters && (<FilterColumn data={props.data} headers={props.headers} setData={setData} sessionName={props.sessionName} />)}
          </div>

          {filteredResult.map((item, itemIndex) =>
            <Card key={item} className={`responsive-card mb-3 ${item[statusColumn]} ${activeColumn >= 5 ? "show-more-less" : ""} ${showMore[itemIndex] ? "show-more" : "show-less"}`}>
              <Card.Header className="responsive-card-header" hidden={paginationView == 'false' ? true : false}>
                {!props.noCheckbox && <div>
                  {(props.checkBoxValidation == undefined || props.checkBoxValidation(item)) &&
                    <Form.Check name="select"
                      checked={selectedData.length > 0 ? (selectedData.filter(e => (e === item)).length <= 0) ? false : true : false
                      }
                      className='custom-checkbox'
                      onChange={(e) => {
                        handleChangeCheckbox(e, item);
                      }} ></Form.Check>
                  }
                </div>}
                <div>
                  {props.icons?.map((icon, index) => <>
                    <Image className={`responsive-card-icon`} key={icon.src} src={icon.src} onClick={() => { icon.click(item) }}></Image>
                  </>)}
                </div>
              </Card.Header>
              <Card.Body className={`responsive-card-body`}>
                {gridHeader.map((header, index) =>
                // for hide show column
                {
                  let formattedValue = (header.formatter || header.dataType === 'date') ? formatDate(item[header.columnName]) : item[header.columnName];

                  //  let formattedValue = header.formatter ? header.formatter(item[header.columnName], header, item) : item[header.columnName];
                  let displayValue = header.cssFormatter ? header.cssFormatter(formattedValue, header, item, itemIndex) : formattedValue;
                  return (header.displayIndication != undefined &&
                    <Card.Body key={`${header.columnName}-${index}`} className={`responsive-row`} onClick={() => (paginationView == 'false' && tableApproverView == true)}>
                      <span style={{ fontWeight: 'bold' }} className="responsive-header">{header.displayName}</span>
                      <span className={`responsive-value ${displayValue}`}>
                        {header.switch &&
                          <Switch
                            isOn={item[statusColumn] == constants.ACTIVE ? true : false}
                            index={itemIndex}

                          ></Switch>}
                        {displayValue}</span>
                    </Card.Body>
                  )
                }
                )}
              </Card.Body>
              <Card.Footer className={`responsive-card-footer`}>
                <span className="responsive-card-show-more" onClick={() => { handleShowMore(itemIndex) }}>{showMore[itemIndex] ? "Show less" : "Show More"}</span>
              </Card.Footer>
            </Card>
          )}
        </div>

      </Row>
      {data && data.length > 0 && paginationView !== "false" && (
        <Pagination
          currentPage={currentPage}
          totalCount={data ? data.length : 0}
          // totalCount1={filteredData ? filteredData.length : 0}
          data={data}
          pageSize={pageSize}
          setPageSize={setPageSize}
          setCurrentPage={setCurrentPage}
          dataType={props.dataType}
          sessionName={props.sessionName}
        />
      )}
    </Container>
  );
}
